<template>
  <button
    class="border-0
          flex items-center justify-center
          text-lg cursor-pointer
          transition duration-300 ease-in-out
          hover:no-underline hover:bg-grey-200
          icon-button px-0"
    :class="classes"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'IconButton',
  emits: ['click'],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isRounded: {
      type: Boolean,
      default: true,
    },
    bgColorClass: {
      type: String,
      default: 'bg-white',
    },
    textColorClass: {
      type: String,
      default: 'text-green-600',
    },
    size: {
      type: String,
      default: '',
      validator: size => ['', 'small', 'normal', 'large'].indexOf(size) !== -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      const arr = [];
      arr.push(this.bgColorClass);
      arr.push(this.textColorClass);
      arr.push(this.size === 'small' ? 'h-8 w-8' : 'h-10 w-10');
      arr.push(this.isRounded ? 'rounded-md' : '');
      return arr;
    },
  },
};
</script>

<style lang="scss">
  @use "@sass/design-system/variables" as ds-variables;

  .icon-button.is-loading {
    color: transparent;
    opacity: .7;
    position: relative;

    &::after {
      content: ' ';
      background: center center no-repeat;
      background-size: cover;
      border-radius: 50%;
      border: .15em solid;
      border-color: currentColor currentColor currentColor transparent;
      width: 1em;
      height: 1em;
      position: absolute;
      top: calc(50% - .5em);
      left: calc(50% - .5em);
      color: ds-variables.$green-600 !important;
      display: inline-block;
      animation: loading-spin 1s infinite;
    }
  }

</style>
